import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'
import "../../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars'

const useStyles = makeStyles((theme: Theme) => ({
  navIcon: {
    color: '#999 !important',
    fontSize: '1.7rem !important',
    fontWeight: '900 !important'
  },
  logo: {
    transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
    margin: '0 auto'
  },
  logoHolder: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paragraph: {
    lineHeight: 1.6,
    color: '#555',
    fontSize: '0.978rem',
    fontStyle: 'normal',
    textAlign: 'left',
    fontWeight: '400',
    marginBottom: '30px'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '1rem',
    [theme.breakpoints.down('md')]: {
      padding: '0rem'
    }
  },
  linkButton: {
    color: '#fff !important',
    backgroundColor: '#5d307f',
    borderColor: '#5d307f',
    marginLeft: '10px',
    display: 'inline-block',
    fontWeight: 400,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    userSelect: 'none',
    border: '1px solid transparent',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    borderRadius: '0.25rem',
    textDecoration: 'none',
    transition: 'all 0.15s ease-in-out',
    "&:hover": {
      color: '#000 !important',
      backgroundColor: '#e37927',
      borderColor: '#e37927'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      marginTop: '5px',
      display: 'block'
    }
  },
  asideInner: {
    padding: '1rem',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '1rem'
    }
  }
}))

interface Props {
  dropdown: string
  handleDropDownClose: () => void
  setDropdownOpt1: React.Dispatch<React.SetStateAction<string>>
  dropdownOpt1: string
  setDropdownOpt2: React.Dispatch<React.SetStateAction<string>>
}

const CableDropdownPopup: React.FC<Props> = ({
  handleDropDownClose,
  dropdown,
  setDropdownOpt1,
  dropdownOpt1,
  setDropdownOpt2
}) => {
  const classes = useStyles()
  const [search, setSearch] = useState('')

  const handleDropdownOpt1 = (selected: string) => {
    setDropdownOpt2('')
    setDropdownOpt1(selected)
    handleDropDownClose()
  }

  const providers = ['Xfinity', 'Spectrum', 'DirecTV', 'Dish', 'Cox', 'Optimum']

  const filteredProviders = providers.filter(provider =>
    provider.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div id='cable-dropdown-select-popup' className='sidebar-wrapper-receive-funds'>
      <div className='sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable'>
        <aside className='sidebar-receive-funds-beneficiaries'>
          <div className='funds-beneficiaries-header'>
            <h6 id='bill-select-cable-type' className='funds-ben-header-h6 justdisplaynone'>
              Select Cable Provider
            </h6>
            <button
              type='button'
              className='btn-beneficiaries-funds close'
              onClick={handleDropDownClose}
            >
              ×
            </button>
          </div>

          <div className='funds-beneficiaries-body'>
            <div style={{ margin: '1rem 0' }}>
              <div>
                <input
                  type='text'
                  name='funds-beneficiaries-search'
                  id='funds-beneficiaries-search'
                  className='funds-beneficiaries-search'
                  placeholder='Search provider...'
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  style={{ cursor: 'text' }}
                />
              </div>

              <div style={{ marginBottom: '3rem', height: '230px' }}>
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <Scrollbars
                    style={{ transform: 'translateZ(-100px)', height: '230px' }}
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                  >
                    <div
                      id='bill-select-cable-type-options'
                      className='justdisplaynone'
                      style={{ padding: '1rem 0' }}
                    >
                      {filteredProviders.map(provider => (
                        <div
                          key={provider}
                          typeof='button'
                          className='bills-dropdown-button-xxx'
                          onClick={() => handleDropdownOpt1(provider)}
                        >
                          <p className='bills-dropdown-button-xxx-p'>{provider}</p>
                        </div>
                      ))}
                      {filteredProviders.length === 0 && (
                        <p style={{ padding: '1rem', color: '#777', textAlign: 'center' }}>
                          No match found
                        </p>
                      )}
                    </div>
                  </Scrollbars>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default CableDropdownPopup
